import React from "react";
import { css } from "aphrodite";
import { styles } from "./SearchListPageStyle";
import { TabBar } from "src/components/TabBar";
import { Card, CardBody, ListGroup, ListGroupItem } from "reactstrap";
import { URLBuilder } from "src/core/URLBuilder";
import { JsonConvert } from "json2typescript";
import axios from "axios";
import { RequestState } from "src/models/RequestState";
import { SearchResult } from "src/models/SearchResult";
import { SearchOptions } from "src/models/SearchOptions";
import { Participant } from "src/models/Participant";
import { ProposalDetailDialog } from "src/components/dialogs/ProposalDetailDialog";
import { ProposalListItem, ProposalParticipant } from "src/models/ProposalListItem";
import { AwardListItem, AwardParticipant } from "src/models/AwardListItem";
import { AwardDetailDialog } from "src/components/dialogs/AwardDetailDialog";
import { PublicationAuthor, PublicationListItem } from "src/models/PublicationListItem";
import { PublicationDetailDialog } from "src/components/dialogs/PublicationDetailDialog";
import millify from "millify";

interface ISearchListPageProps {
    history: any,
    searchOptions: string
}

class SearchListPageState {
    public readonly selectedTab: number = 2;
    public readonly requestState: RequestState = RequestState.NOT_ASKED;
    public readonly data: SearchResult = new SearchResult();
    public readonly error: string = "";
    public readonly searchOptions: SearchOptions = new SearchOptions();
    public readonly isProposalDialogOpen: boolean = false;
    public readonly isAwardDialogOpen: boolean = false;
    public readonly isPublicationDialogOpen: boolean = false;
    public readonly clickedProposalListItem: ProposalListItem;
    public readonly clickedAwardListItem: AwardListItem;
    public readonly clickedPublicationItem: PublicationListItem;
}

export class SearchListPage extends React.Component<ISearchListPageProps, SearchListPageState> {
        
    constructor(props: ISearchListPageProps){
        super(props);
        this.state = new SearchListPageState();
    }

    public async componentDidMount() {

        //decode the search options string
        try{
            const jsonConvert = new JsonConvert();
            const searchOptions = jsonConvert.deserialize(JSON.parse(this.props.searchOptions), SearchOptions)
            this.setState({...this.state,requestState: RequestState.LOADING,searchOptions: searchOptions})
            const url = URLBuilder.search(searchOptions)
            axios.get(url).then((res)=> {
                if(res.status === 200){
                    try{
                        const data = jsonConvert.deserialize(res.data, SearchResult);
                        this.setState({...this.state, requestState: RequestState.SUCCESS, data: data})
                    }catch(err){
                        this.setState({...this.state, requestState: RequestState.ERROR, error: err.toString()})
                    }
                }else{
                    this.setState({...this.state, requestState: RequestState.ERROR, error: res.statusText})
                }    
            }).catch((err)=>{
                this.setState({...this.state, requestState: RequestState.ERROR, error: err.toString()})
            });
        }catch(err){
            this.setState({...this.state, requestState: RequestState.ERROR, error: err.toString()})
        }        
    }

    public render() {
        let content;
            
        if(this.state.requestState === RequestState.SUCCESS){
            let searchResults ;
            if(this.state.selectedTab === 0){
                searchResults = this.state.data.proposals.map(this.buildProposalListItem);
            }else if(this.state.selectedTab === 1){
                searchResults = this.state.data.awards.map(this.buildAwardListItem);
            }else{
                searchResults = this.state.data.publications.map(this.buildPublicationItem);
            }
            content = (
                <ListGroup flush={true} className={css(styles.resultsList)} >
                    {searchResults}
                </ListGroup>
            )
        }else if(this.state.requestState === RequestState.LOADING){
            content = (
                <div>
                    Loading
                </div>
            )
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div>
                    {this.state.error}
                </div>
            )
        }else{
            content = (
                <div>

                </div>
            )
        }

        let searchTerm;

        if(this.state.searchOptions.keyPhrase.length !== 0
             && this.state.searchOptions.firstName.length !==0
             && this.state.searchOptions.lastName.length !== 0 ){
            searchTerm = this.state.searchOptions.firstName + " " + this.state.searchOptions.lastName + " and " + this.state.searchOptions.keyPhrase;
        }else if(this.state.searchOptions.keyPhrase.length !== 0){
            searchTerm = this.state.searchOptions.keyPhrase;
        }else {
            searchTerm = this.state.searchOptions.firstName + " " + this.state.searchOptions.lastName
        }

        return (
            <React.Fragment>
                <div id="page" className={css(styles.page)} >
                
                    <div id="searchTerm" className={css(styles.searchTerm)} >
                        Showing search results for "{searchTerm}"
                    </div>
                    {/*
                    <TabBar tabs={["Publications"]}
                                activeIndex={this.state.selectedTab}
                                onTabClick={this.onTabSelected}
                                showCP={false}
                                />
                       */}
                    {/*<TabBar tabs={["Proposals","Awards","Publications"]}*

                                activeIndex={this.state.selectedTab}
                                onTabClick={this.onTabSelected}
                                showCP={false}
                                />
                    */}
                    <div id="results" >
                        <Card id="proposals" className={css(styles.card)}>
                            <CardBody >
                                {content}
                            </CardBody>
                        </Card>
                    </div>

                </div>
                {/*{this.buildProposalDetailDialog()}
                {this.buildAwardDetailDialog()}*/}
                {/*{this.buildPublicationDialog()}*/}
            </React.Fragment>
            
        );
    }

   
    private onTabSelected = (value: number) => {
        this.setState({...this.state, selectedTab: value})
    }

    private buildProposalListItem = (item: ProposalListItem, index: number) => {
        const participants: ProposalParticipant[] = [];
        let budget = 0;
        for(const project of item.projects){
            budget = project.budget + budget;
            for (const participant of project.participants){
                if(participants.indexOf(participant) !== -1){
                    participants.push(participant)
                }
            }
        }
        return (<ListGroupItem key={index} >
                <div style={{minWidth: "100%"}} >
                    <h6>
                        <div className={css(styles.resultListItemTitle)} onClick={(e)=>{this.onProposalClick(item)}} >
                            {item.title}
                        </div>
                    </h6>
                    <div className={css(styles.participantsContainer)} >
                        {participants.map((participant: Participant, index_part: number)=>{
                            return this.buildParticipant(participant,index_part,participants.length)
                        })}
                    </div>
                    <div>
                        Amount: {"$"+ millify(budget)}
                    </div>
                    <div style={{ marginBottom: "10px" }} >
                        {item.agency}, {item.begin_date}
                    </div>
                    <div>
                        {item.description}
                    </div>
                </div>
        </ListGroupItem>);
    }

    private buildAwardListItem = (item: AwardListItem, index: number) => {
        const participants: AwardParticipant[] = [];
        for(const project of item.projects){
            for (const participant of project.participants){
                if(participants.indexOf(participant) !== -1){
                    participants.push(participant)
                }
            }
        }
        return (<ListGroupItem key={index} >
                <div style={{minWidth: "100%"}} >
                    <h6>
                        <div className={css(styles.resultListItemTitle)} onClick={(e)=>{this.onAwardClick(item)}} >
                            {item.title}
                        </div>
                    </h6>
                    <div className={css(styles.participantsContainer)} >
                        {participants.map((participant: Participant, index_part: number)=>{
                            return this.buildParticipant(participant,index_part,participants.length)
                        })}
                    </div>
                    <div>
                        Amount: {0}
                    </div>
                    <div style={{ marginBottom: "10px" }} >
                        {item.agency}, {item.begin_date}
                    </div>
                    <div>
                        {item.description}
                    </div>
                </div>
        </ListGroupItem>);
    }

    private buildParticipant = (participant: Participant, index: number, length: number) => {
        
        let content;

        let seperator;
        if(index < length - 1){
            seperator = ","
        }else{
            seperator = ""
        }

        if(participant.ud_flag){
            content = (
                <a href={`#faculty/${participant.id}`} target="_" >
                    {participant.first_name + " " + participant.last_name + seperator} &nbsp;
                </a>
            )
        }else{
            content = (
                <div>
                    {participant.first_name + " " + participant.last_name + seperator } &nbsp;
                </div>
            );
        }

        return (
            <div key={index} className={css(styles.participant)}  >
                {content}
            </div>
        )
    }

    private onProposalClick = (clickedItem: ProposalListItem) => {
        this.setState({...this.state, isProposalDialogOpen: true, clickedProposalListItem: clickedItem})
    }

    private buildProposalDetailDialog = () => {
        return (<ProposalDetailDialog isOpen={this.state.isProposalDialogOpen}
                                         onClose={this.onProposalDialogClose}
                                         data={this.state.clickedProposalListItem}/>)
    }

    private onProposalDialogClose = () => {
        const newState = {...this.state, isProposalDialogOpen: false};
        this.setState(newState);
    }

    private onAwardClick = (clickedItem: AwardListItem) => {
        this.setState({...this.state, isAwardDialogOpen: true, clickedAwardListItem: clickedItem})
    }

    private buildAwardDetailDialog = () => {
        return (<AwardDetailDialog isOpen={this.state.isAwardDialogOpen}
                                         onClose={this.onAwardDialogClose}
                                         data={this.state.clickedAwardListItem}/>)
    }

    private onAwardDialogClose = () => {
        const newState = {...this.state, isAwardDialogOpen: false};
        this.setState(newState);
    }

    private buildPublicationItem = (publication: PublicationListItem, index: number) => {
        return (
            <ListGroupItem key={index} >
                <div>
                    <h6>
                        <div className={css(styles.resultListItemTitle)} onClick={(event: any)=>{this.onPublicationItemClick(publication)}}>
                            {publication.title}
                        </div>
                    </h6>
                    <div style={{ fontSize: "12px" }}>
                        {this.buildCoauthors(publication.authors)}
                    </div>
                    <div style={{ fontSize: "10px" }} >
                        {publication.source_name}, {publication.pub_date}
                    </div>
                </div>
            </ListGroupItem>);
    }

    private buildCoauthors(coauthors: PublicationAuthor[]): string {
        let data;
        if(coauthors.length > 10){
            data = coauthors.slice(0,10);
        }else{
            data = coauthors;
        }

        const combinedNames = data.map((author: PublicationAuthor)=>{
            return author.first_name + " " + author.last_name; 
        })

        const coauthor_str = combinedNames.join(", ")
        return coauthor_str;
    }

    private onPublicationItemClick = (publication: PublicationListItem) => {
        const newState = {...this.state, isPublicationDialogOpen: true, clickedPublicationItem: publication};
        this.setState(newState);
    }

    private onPublicationDialogClose = () => {
        const newState = {...this.state, isPublicationDialogOpen: false};
        this.setState(newState);
    }

    private buildPublicationDialog = () => {
        return (<PublicationDetailDialog isOpen={this.state.isPublicationDialogOpen}
                                         onClose={this.onPublicationDialogClose}
                                         data={this.state.clickedPublicationItem}
                                         isMinimal={true}
                                         />)
    }


}


// WEBPACK FOOTER //
// ./src/pages/SearchListPage.tsx